// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/modal.ts
export const Modal = {
  baseStyle: (props) => ({
    dialog: {
      borderRadius: '1rem',
      boxShadow: 'xl',
    },
  }),
}
